module.exports = __webpack_public_path__ + "img/ki-logo-icon.85a1a5fd.png";